module.exports = __webpack_public_path__ + "img/message_bg.c7cb77cc.gif";